import { styled } from '@mui/material/styles';

import { Section } from 'components/styledComponents';

export const HeaderSection = styled(Section)(({ theme }) => ({
  background: theme.color.background.section,
  padding: theme.spacing(5, 0, 8, 0)
}));
